import React from 'react';
import FurnitureSalesCategory from 'components/Tvendo/BusinessPartner/DataMaster/FurnitureSalesCategory/List.js';

export default function () {
  return <FurnitureSalesCategory />;
}
